import React, {useEffect, useState} from 'react';
import ApiActions from 'go/actions/api';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {connect} from 'react-redux';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import {push} from 'react-router-redux';

const ProfileUpdateModal = ({
  refreshToken,
  token,
  navigateToProfile,
  toggleProfileUpdateModal,
}) => {
  const [bannerReport, setBannerReport] = useState(null);

  useEffect(() => {
    const cookies = new Cookies(null, {path: '/'});
    const isBannerCookie = cookies.get('bannerReport');

    if (!_.isEmpty(isBannerCookie)) {
      const bannerReportChange = decodeCookie(isBannerCookie);
      setBannerReport(bannerReportChange);
    }
  }, []);

  const ignoreDefaultWithConfirm = (e) => {
    refreshToken(token);
    toggleProfileUpdateModal(false);
    setBannerReport(null);
  };

  const navigateToProfilePage = (e) => {
    refreshToken(token);
    navigateToProfile();
    toggleProfileUpdateModal(false);
  };

  const decodeCookie = (cookie) => {
    const bannerReport = atob(cookie);
    const bannerReportObj = JSON.parse(bannerReport);
    if (bannerReportObj && bannerReportObj.hasOwnProperty('profileChange')) {
      return bannerReportObj.profileChange;
    }
  };

  let modal = null;
  if (bannerReport) {
    modal = (
      <FemaGoModal
        size="small"
        title={'Update to your profile'}
        className="ProfileUpdateModal"
        open={bannerReport}
        onClose={ignoreDefaultWithConfirm}
        buttonText={'Continue'}
        cancelButtonText={'View Your Profile'}
        confirmAction={ignoreDefaultWithConfirm}
        cancelAction={navigateToProfilePage}
      >
        {'Your profile has been updated. Please review the changes for accuracy.'}
      </FemaGoModal>
    );
  }
  return modal;
};

const mapStateToProps = (state) => {
  return {
    token: state.auth ? state.auth.token : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  refreshToken: (token) => {
    const action = ApiActions.auth.refresh(token);
    return dispatch(action);
  },
  toggleProfileUpdateModal: (toggle) => {
    const action = ApiActions.auth.toggleProfileUpdateModal(toggle);
    return dispatch(action);
  },
  navigateToProfile: () => {
    dispatch(push('/profile'));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUpdateModal);
